import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-reboot-comp',
  templateUrl: './reboot-comp.component.html',
  styleUrls: ['./reboot-comp.component.scss']
})
export class RebootCompComponent implements OnInit {

  constructor() { }
  @Output() rModal: EventEmitter<any> = new EventEmitter();
  ngOnInit(): void {
  }
  sendCRM() {
    this.rModal.emit(false);
  } 
}
